import { KngLegalActeForm } from './kng-legal-acte-form.webcomponent';
import './kng-legal-acte-form.style';

export { KngLegalActeForm };

export function registerLegalActeForm(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  if (!window.customElements.get('kng-legal-acte-form')) {
    window.customElements.define('kng-legal-acte-form', KngLegalActeForm as any);
  }

  if (!window.customElements.get('sl-legal-act')) {
    class SlLegalAct extends KngLegalActeForm {}
    window.customElements.define('sl-legal-act', SlLegalAct as any);
  }

  (window as any).KngLegalActeForm = KngLegalActeForm;
  (window as any).registerLegalActeForm = registerLegalActeForm;
  return true;
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerLegalActeForm, { once: true });
  } else {
    registerLegalActeForm();
  }
}
